import { type ActivationRules, isDateActive } from '../../../core/util/date';
import Balls from '../Balls';
import Rainbow from '../Rainbow';

const pride: ActivationRules = {
  start: {
    day: 1,
    month: 5,
  },
  end: {
    day: 30,
    month: 5,
  },
};

export default function Loader(): React.ReactNode {
  const today: Date = new Date();
  const isDk = window.location.hostname.split('.').pop()?.toUpperCase() == 'DK';

  if (isDateActive(pride, today) && !isDk) {
    return <Rainbow />;
  } else {
    return <Balls />;
  }
}
